import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";

const EditRoomType = () => {
  return (
    <Edit
      title="Редактиране на тип стая"
      mutationMode="pessimistic"
      transform={({
        descriptionBg,
        descriptionEn,
        quadrature,
        terrace,
        capacity,
        roomRental,
        costPerPerson,
        discountChild,
        discountChildren,
        suitableForFamily,
        suitableForDisabled,
      }) => ({
        descriptionBg,
        descriptionEn,
        quadrature,
        terrace,
        capacity,
        roomRental,
        costPerPerson,
        discountChild,
        discountChildren,
        suitableForFamily,
        suitableForDisabled,
      })}
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditRoomType;
